import { render } from "./SLA.vue?vue&type=template&id=039afade"
import script from "./SLA.vue?vue&type=script&setup=true&lang=js"
export * from "./SLA.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SLA.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "039afade"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('039afade', __exports__)) {
    api.reload('039afade', __exports__)
  }
  
  module.hot.accept("./SLA.vue?vue&type=template&id=039afade", () => {
    api.rerender('039afade', render)
  })

}


export default __exports__